import { render, staticRenderFns } from "./OrderEditLogs.vue?vue&type=template&id=66080cf7&scoped=true&"
import script from "./OrderEditLogs.vue?vue&type=script&lang=js&"
export * from "./OrderEditLogs.vue?vue&type=script&lang=js&"
import style0 from "./OrderEditLogs.vue?vue&type=style&index=0&id=66080cf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66080cf7",
  null
  
)

export default component.exports